<template>
  <div class="backdrop">
    <div class="common-goods">
      <div class="common-goods-list">
        <img class="goods-img" v-if="asset_info.image_url" :src="asset_info.image_url">
        <img class="goods-img" v-else src="../../../assets/images/no-picture.jpg">
        <div class="goods-detail">
          <div class="item name">
            <div class="status green" v-if="asset_info.status == 1">{{asset_info.status_info}}</div>
            <div class="status blue" v-else-if="asset_info.status == 2">{{asset_info.status_info}}</div>
            <div class="status cyan" v-else-if="asset_info.status == 3">{{asset_info.status_info}}</div>
            <div class="status purple" v-else-if="asset_info.status == 4">{{asset_info.status_info}}</div>
            <div class="status orange" v-else-if="asset_info.status == 5">{{asset_info.status_info}}</div>
            <div class="status" v-else>{{asset_info.status_info}}</div>
            {{asset_info.goods_name}}
          </div>
          <div class="item">资产编码：{{asset_info.asset_num}}</div>
          <div class="item">使用人：{{asset_info.keeper_member_name}}</div>
          <div class="item">存放区域：{{asset_info.area_name}}</div>
        </div>
      </div>
    </div>
    <div class="tag-wrapper common">
      <div class="row">
        <div>物资类型</div>
        <div>资产</div>
      </div>
      <div class="row">
        <div>物品编码</div>
        <div>{{asset_info.goods_num}}</div>
      </div>
      <div class="row">
        <div>分类</div>
        <div><span v-if="asset_info.category_pname">{{asset_info.category_pname}}-</span>{{asset_info.category_name}}</div>
      </div>
      <div class="row">
        <div>价值</div>
        <div>{{asset_info.original_price}}</div>
      </div>
      <div class="row">
        <div>供应商</div>
        <div>{{asset_info.supplier_name}}</div>
      </div><div class="row">
        <div>规格型号</div>
        <div>{{asset_info.specification}}</div>
      </div>
      <div class="row">
        <div>品牌商标</div>
        <div>{{asset_info.brand}}</div>
      </div>
      <div class="row">
        <div>所属仓库</div>
        <div>{{asset_info.village_name}}-{{asset_info.storage_name}}</div>
      </div>
      <div class="row">
        <div>购入日期</div>
        <div>{{asset_info.purchase_time_info}}</div>
      </div>
      <div class="row">
        <div>使用期限（月）</div>
        <div>{{asset_info.service_life}}</div>
      </div>
      <div class="row">
        <div>创建日期</div>
        <div>{{asset_info.create_time_info}}</div>
      </div>
      <div class="row">
        <div>入库来源</div>
        <div>{{asset_info.input_delivery_type_name}}</div>
      </div>
      <div class="row" v-for="(item, index) in asset_info.attribute_msg" :key="index">
        <div>{{item.goods_attribute_name}}</div>
        <div v-if="item.type== 3">{{item.option_text}}</div>
        <div v-else>{{item.value}}</div>
      </div>
      <div class="row">
        <div>备注</div>
        <div>{{asset_info.remark}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetDetail',
  metaInfo: {
    title: '资产详情'
  },
  data () {
    return {
      asset_info: [],
      asset_id: 0
    }
  },
  computed: {
    ...mapState(['villageId', 'userId'])
  },
  created () {
    this.asset_id = this.$route.query.asset_id
    this.getAssetDetail()
  },
  methods: {
    getAssetDetail () {
      this.axios.post('/wechat/Asset/AssetDetail', {
        member_id: this.memberId,
        village_id: this.villageId,
        asset_id: this.asset_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.asset_info = res.data.data
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.tag-wrapper {
  margin-top: 10px;
}
.tag-wrapper .row {
  display: flex;
  font-size: 14px;
  border-bottom: 1px solid #f6f6f6;
  padding: 8px 0;
}
.tag-wrapper .row div:last-child {
  flex: 1;
  text-align: right;
}
.status {
  padding: 1px 8px;
  font-size: 13px;
  border-radius: 10px;
  font-weight: normal;
  display: inline-block;
  margin-right: 6px;
  color: #ffffff;
  background-color: #b9b9b9;
}
.status.green {
  background-color: #35c53b;
}
.status.orange {
  background-color: #fa6b2c;
}
.status.blue {
  background-color: #25ade0;
}
.status.purple {
  background-color: #d025e0;
}
.status.cyan {
  background-color: #25e0c7;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Asset/AssetDetail.vue